import { render, staticRenderFns } from "./OpeningHourItem.vue?vue&type=template&id=13d5ff45&scoped=true&"
import script from "./OpeningHourItem.vue?vue&type=script&lang=ts&"
export * from "./OpeningHourItem.vue?vue&type=script&lang=ts&"
import style0 from "./OpeningHourItem.vue?vue&type=style&index=0&id=13d5ff45&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d5ff45",
  null
  
)

export default component.exports